import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BulkSummaryCards from "../payrole-tabs/BulkSummaryCards";
import BulkPayrollProcessing from "../payrole-tabs/BulkPayrollProcessing";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { fetchEmployeePayrollData } from "../../../redux/payrole-reducers/payroleSlice";

const BulkProcess = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { employeePayrollLoading } = useSelector((state) => state.payrole);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isGym = userInfoData?.account_type === "gym";
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    accountType: "",
    selectedMonth: "",
    isActive: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    stack_holder_approval: "approved",
    month: allFilters.selectedMonth?.value || "",
    status: allFilters.isActive?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniStats = {
    total_eligible_employees: 0,
    total_selected_employees: 0,
    total_payout: 0,
    total_processed_employees: 0,
  };
  const [statsData, setStatsData] = useState(iniStats);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getEmployeePayrollData = (filters) => {
    dispatch(
      fetchEmployeePayrollData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getEmployeePayrollData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      account_type: allFilters.accountType?.value || "",
      month: allFilters.selectedMonth?.value || "",
      status: allFilters.isActive?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.accountType,
    allFilters.selectedMonth,
    allFilters.isActive,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <CmnFilters
        from={"payrole-processor-logs"}
        clickedCard={"export-payroll"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        searchPlaceHolder="Search by staff name, mobile, email..."
        isLoading={employeePayrollLoading}
      />

      <BulkSummaryCards statsData={statsData} />

      <BulkPayrollProcessing
        userInfoData={userInfoData}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        filters={filters}
        callFunction={() => getEmployeePayrollData(filters)}
        setStatsData={setStatsData}
      />
    </>
  );
};

export default BulkProcess;
